/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useQuery } from '@apollo/client';
import { string, shape } from 'prop-types';
import mbpLogger from '@module-logger/mbp';
import { useSelector } from 'react-redux';
import { GRAPHQL_ENV } from '../../../../gql';
import findContent from '../../../../gql/queries/findContent';
import { getBrandName } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import NupV2 from '../../../ContentTypeComponents/NupV2/NupV2';

const MarketingSpotsNupPDP = ({ productData }) => {
    const brand = useSelector(getBrandName);
    const findContentOptions = {
        brand,
        contentType: 'marketing_spots',
        query: '\\"title\\" : \\"PDP Nup capability\\"',
        reference: ['spots.nup.reference'],
    };
    const GET_MARKETING_SPOT = findContent(findContentOptions);

    const { data, error } = useQuery(GET_MARKETING_SPOT);

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: GET_MARKETING_SPOT,
            component: 'MarketingSpotsNupPDP.js',
            message: 'Error loading data from Graphql',
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }
    const productidList = data?.findContent?.content?.entries?.[0]?.productid_list;
    const itemArr = productidList?.toUpperCase().split(/[\s*]+|(,\s*)/g); // matches spaces, commas and some comma/space combos. Not necessary to deep-clean it as everything else will be ignored regardless.
    const currentProduct = productData.partNumber.toUpperCase(); // normalize
    const i = itemArr?.indexOf(currentProduct);
    if (i === -1) { return null; }

    const content = data?.findContent?.content?.entries?.[0]?.spots?.[0]?.nup || '';
    return (
        <>
            <NupV2 data={content} />
        </>
    );
};

MarketingSpotsNupPDP.propTypes = {
    productData: shape({
        partNumber: string,
    }).isRequired,
};

export default MarketingSpotsNupPDP;
